export const DASHBOARD_MENU_KEY = "dashboard";
export const HISTORY_MENU_KEY = "history";

export type SidebarMenuKey = typeof DASHBOARD_MENU_KEY | typeof HISTORY_MENU_KEY;
